import Link from 'next/link';
import { useSession } from 'next-auth/react';
import { Fragment } from 'react';
import BacteriaFooterComponent from '../src/ErrorHandler/BacteriaFooterComponent';
import ErrorDisplay from '../src/ErrorHandler/ErrorDisplayComponent';
import { getLayout } from '../src/Layouts/Layout';
import Color from '../src/theme/colors';

const AccessDenied = () => {
  const { status } = useSession();
  const isUserLoggedIn = status === 'authenticated';
  const errorCode: number = 404;
  const errorName = 'Page not found';
  const errorDescriptionFragmentSignIn = (
    <Fragment>
      The requested page couldn’t be found. <br /> Please go back and try again.
    </Fragment>
  );
  const errorDescriptionFragmentSignOut = (
    <Fragment>
      The requested page couldn’t be found. <br />
      <Link href='/' style={{ color: Color.teal }}>
        Sign in to Karius
      </Link>{' '}
      for test ordering and results.
    </Fragment>
  );
  return (
    <>
      <ErrorDisplay
        errorCode={errorCode}
        errorName={errorName}
        errorDescriptionFragment={isUserLoggedIn ? errorDescriptionFragmentSignIn : errorDescriptionFragmentSignOut}
        shouldDisplayLogoDiv={!isUserLoggedIn}
      />
      <BacteriaFooterComponent />
    </>
  );
};
AccessDenied.getLayout = getLayout;

export default AccessDenied;
